import React from 'react';
import Slider from '@material-ui/core/Slider';
import { withStyles, Theme } from '@material-ui/core/styles';

interface SliderFieldProps {
  input: object & {
    onChange: (value: any) => void;
    name: string;
    value: any;
  };
  initialValue: any;
}

const SilderWithStyles = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.primary.main,
    height: 3,
    padding: '13px 0',
  },
  thumb: {
    height: 32,
    width: 32,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    marginTop: -15,
    marginLeft: -16,
    boxShadow: '#ebebeb 0px 2px 2px',
    '&:focus,&:hover,&$active': {
      boxShadow: '#ccc 0px 2px 3px 1px',
    },
    '& .bar': {
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  disabled: {
    '& .MuiSlider-thumb': {
      height: 32,
      width: 32,
      marginTop: -15,
      marginLeft: -16,
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 3,
  },
  rail: {
    color: '#d8d8d8',
    opacity: 1,
    height: 3,
  },
}))(Slider);

const SliderField = ({
  input: { onChange, name, value },
  initialValue,
  ...custom
}: SliderFieldProps) => (
  <SilderWithStyles
    onChange={(event, value) => {
      onChange(value);
    }}
    name={name}
    value={value || initialValue}
    {...custom}
  />
);

export default SliderField;
